/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@angular/forms';
import * as i3 from '../../../app/components/window-form';
import * as i4 from '../../../$$_gendir/node_modules/ng2-completer/components/completer-cmp.ngfactory';
import * as i5 from 'ng2-completer/components/completer-cmp';
import * as i6 from 'ng2-completer/services/completer-service';
import * as i7 from '@ngrx/store/src/store';
const styles_WindowFormComponent:any[] = ([] as any[]);
export const RenderType_WindowFormComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_WindowFormComponent,data:{}});
function View_WindowFormComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'div',[['class',
      'input-group']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),2,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),1,'button',([] as any[]),(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedCancel($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['Cancel']))],
      (null as any),(null as any));
}
export function View_WindowFormComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵpid(0,i1.DatePipe,[i0.LOCALE_ID]),(_l()(),i0.ɵeld(1,0,(null as any),
      (null as any),68,'div',[['class','window-form']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(2,0,(null as any),
      (null as any),67,'div',[['class','wf__content-wrapper']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(3,0,(null as any),
      (null as any),66,'form',[['novalidate','']],[[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'submit'],[(null as any),
          'reset']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('submit' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,5).onSubmit($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('reset' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,5).onReset()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(4,16384,(null as any),0,i2.ɵbf,([] as any[]),
      (null as any),(null as any)),i0.ɵdid(5,16384,(null as any),0,i2.NgForm,[[8,(null as any)],
      [8,(null as any)]],(null as any),(null as any)),i0.ɵprd(2048,(null as any),i2.ControlContainer,
      (null as any),[i2.NgForm]),i0.ɵdid(7,16384,(null as any),0,i2.NgControlStatusGroup,
      [i2.ControlContainer],(null as any),(null as any)),(_l()(),i0.ɵeld(8,0,(null as any),
      (null as any),53,'div',[['class','input-row']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵeld(9,0,(null as any),(null as any),
      9,'div',[['class','input-group day']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵeld(10,0,(null as any),(null as any),
      8,'div',[['class','ig__content-wrapper']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵeld(11,0,(null as any),(null as any),
      5,'ng2-completer',[['id','day'],['name','day']],[[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
          'selected']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.WindowFormComponent = _v.component;
        if (('ngModelChange' === en)) {
          const pd_0:any = ((<any>(_co.daySearchStr = $event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('selected' === en)) {
          const pd_1:any = ((<any>_co.selectedDay($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_CompleterCmp_0,i4.RenderType_CompleterCmp)),i0.ɵdid(12,12697600,(null as any),
      0,i5.CompleterCmp,[i6.CompleterService,i0.ChangeDetectorRef],{minSearchLength:[0,
          'minSearchLength'],openOnFocus:[1,'openOnFocus'],initialValue:[2,'initialValue'],
          datasource:[3,'datasource']},{selected:'selected'}),i0.ɵprd(1024,(null as any),
      i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i5.CompleterCmp]),i0.ɵdid(14,671744,(null as any),0,i2.NgModel,[[2,i2.ControlContainer],
      [8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],{name:[0,'name'],
      model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),i2.NgControl,
      (null as any),[i2.NgModel]),i0.ɵdid(16,16384,(null as any),0,i2.NgControlStatus,
      [i2.NgControl],(null as any),(null as any)),(_l()(),i0.ɵeld(17,0,(null as any),
      (null as any),1,'label',[['for','day']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['Day'])),(_l()(),
      i0.ɵeld(19,0,(null as any),(null as any),10,'div',[['class','input-group start-time']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(20,0,(null as any),(null as any),9,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(21,0,(null as any),(null as any),1,'label',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,
          (null as any),['Start time'])),(_l()(),i0.ɵeld(23,0,(null as any),(null as any),
          6,'input',[['name','startTime'],['step','1800'],['type','time']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.WindowFormComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,24)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,24).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,24)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,24)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>_co.changedStartTime($event,_co.window)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(24,16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i0.ɵdid(26,671744,(null as any),0,i2.NgModel,[[2,
          i2.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i0.ɵppd(27,
          2),i0.ɵprd(2048,(null as any),i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(29,
          16384,(null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵeld(30,0,(null as any),(null as any),10,'div',[['class','input-group end-time']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(31,0,(null as any),(null as any),9,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(32,0,(null as any),(null as any),1,'label',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,
          (null as any),['End time'])),(_l()(),i0.ɵeld(34,0,(null as any),(null as any),
          6,'input',[['name','endTime'],['type','time']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.WindowFormComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,35)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,35).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,35)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,35)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>_co.changedEndTime($event,_co.window)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(35,16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i0.ɵdid(37,671744,(null as any),0,i2.NgModel,[[2,
          i2.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i0.ɵppd(38,
          2),i0.ɵprd(2048,(null as any),i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(40,
          16384,(null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵeld(41,0,(null as any),(null as any),20,'div',[['class','input-group lunch-start-time']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(42,0,(null as any),(null as any),7,'div',[['class','input-group checkbox has-lunchtime']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(43,0,(null as any),(null as any),5,'input',[['id','has-lunchtime'],
          ['name','hasLunchtime'],['type','checkbox']],[[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
          'change'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.WindowFormComponent = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,44).onChange($event.target.checked)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,44).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_2:any = ((<any>(_co.window.hasLunchtime = $event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(44,16384,(null as any),0,i2.CheckboxControlValueAccessor,
          [i0.Renderer2,i0.ElementRef],(null as any),(null as any)),i0.ɵprd(1024,(null as any),
          i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i2.CheckboxControlValueAccessor]),i0.ɵdid(46,671744,(null as any),0,i2.NgModel,
          [[2,i2.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,
          (null as any),i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(48,16384,
          (null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵeld(49,0,(null as any),(null as any),0,'label',[['for','has-lunchtime']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(50,0,(null as any),(null as any),11,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(51,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,
          i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,'ngClass']},(null as any)),
      i0.ɵpod(52,{'dim':0}),(_l()(),i0.ɵeld(53,0,(null as any),(null as any),1,'label',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Lunch hour'])),(_l()(),i0.ɵeld(55,0,(null as any),
          (null as any),6,'input',[['name','lunchStartTime'],['type','time']],[[2,
              'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.WindowFormComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,56)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,56).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,56)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,56)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>_co.changedLunchStartTime($event,_co.window)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(56,16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i0.ɵdid(58,671744,(null as any),0,i2.NgModel,[[2,
          i2.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i0.ɵppd(59,
          2),i0.ɵprd(2048,(null as any),i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(61,
          16384,(null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵeld(62,0,(null as any),(null as any),7,'div',[['class','actions']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(63,0,(null as any),(null as any),6,'div',[['class','input-row']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_WindowFormComponent_1)),
      i0.ɵdid(65,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵeld(66,0,(null as any),(null as any),
          3,'div',[['class','input-group']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵeld(67,0,(null as any),(null as any),
          2,'div',[['class','ig__content-wrapper']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵeld(68,0,(null as any),(null as any),
          1,'button',([] as any[]),(null as any),[[(null as any),'click']],(_v,en,
              $event) => {
            var ad:boolean = true;
            var _co:i3.WindowFormComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedSubmit($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted(69,(null as any),['','']))],
      (_ck,_v) => {
        var _co:i3.WindowFormComponent = _v.component;
        const currVal_14:any = 0;
        const currVal_15:any = true;
        const currVal_16:any = (_co.window.day || _co.days[0]);
        const currVal_17:any = _co.dayCompleter;
        _ck(_v,12,0,currVal_14,currVal_15,currVal_16,currVal_17);
        const currVal_18:any = 'day';
        const currVal_19:any = _co.daySearchStr;
        _ck(_v,14,0,currVal_18,currVal_19);
        const currVal_27:any = 'startTime';
        const currVal_28:any = i0.ɵunv(_v,26,1,_ck(_v,27,0,i0.ɵnov(_v,0),_co.window.startTime,
            'HH:mm'));
        _ck(_v,26,0,currVal_27,currVal_28);
        const currVal_36:any = 'endTime';
        const currVal_37:any = i0.ɵunv(_v,37,1,_ck(_v,38,0,i0.ɵnov(_v,0),_co.window.endTime,
            'HH:mm'));
        _ck(_v,37,0,currVal_36,currVal_37);
        const currVal_45:any = 'hasLunchtime';
        const currVal_46:any = _co.window.hasLunchtime;
        _ck(_v,46,0,currVal_45,currVal_46);
        const currVal_47:any = 'ig__content-wrapper';
        const currVal_48:any = _ck(_v,52,0,!_co.window.hasLunchtime);
        _ck(_v,51,0,currVal_47,currVal_48);
        const currVal_56:any = 'lunchStartTime';
        const currVal_57:any = i0.ɵunv(_v,58,1,_ck(_v,59,0,i0.ɵnov(_v,0),_co.window.lunchStartTime,
            'HH:mm'));
        _ck(_v,58,0,currVal_56,currVal_57);
        const currVal_58:any = _co.window.isEditing;
        _ck(_v,65,0,currVal_58);
      },(_ck,_v) => {
        var _co:i3.WindowFormComponent = _v.component;
        const currVal_0:any = i0.ɵnov(_v,7).ngClassUntouched;
        const currVal_1:any = i0.ɵnov(_v,7).ngClassTouched;
        const currVal_2:any = i0.ɵnov(_v,7).ngClassPristine;
        const currVal_3:any = i0.ɵnov(_v,7).ngClassDirty;
        const currVal_4:any = i0.ɵnov(_v,7).ngClassValid;
        const currVal_5:any = i0.ɵnov(_v,7).ngClassInvalid;
        const currVal_6:any = i0.ɵnov(_v,7).ngClassPending;
        _ck(_v,3,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
        const currVal_7:any = i0.ɵnov(_v,16).ngClassUntouched;
        const currVal_8:any = i0.ɵnov(_v,16).ngClassTouched;
        const currVal_9:any = i0.ɵnov(_v,16).ngClassPristine;
        const currVal_10:any = i0.ɵnov(_v,16).ngClassDirty;
        const currVal_11:any = i0.ɵnov(_v,16).ngClassValid;
        const currVal_12:any = i0.ɵnov(_v,16).ngClassInvalid;
        const currVal_13:any = i0.ɵnov(_v,16).ngClassPending;
        _ck(_v,11,0,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,
            currVal_13);
        const currVal_20:any = i0.ɵnov(_v,29).ngClassUntouched;
        const currVal_21:any = i0.ɵnov(_v,29).ngClassTouched;
        const currVal_22:any = i0.ɵnov(_v,29).ngClassPristine;
        const currVal_23:any = i0.ɵnov(_v,29).ngClassDirty;
        const currVal_24:any = i0.ɵnov(_v,29).ngClassValid;
        const currVal_25:any = i0.ɵnov(_v,29).ngClassInvalid;
        const currVal_26:any = i0.ɵnov(_v,29).ngClassPending;
        _ck(_v,23,0,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25,
            currVal_26);
        const currVal_29:any = i0.ɵnov(_v,40).ngClassUntouched;
        const currVal_30:any = i0.ɵnov(_v,40).ngClassTouched;
        const currVal_31:any = i0.ɵnov(_v,40).ngClassPristine;
        const currVal_32:any = i0.ɵnov(_v,40).ngClassDirty;
        const currVal_33:any = i0.ɵnov(_v,40).ngClassValid;
        const currVal_34:any = i0.ɵnov(_v,40).ngClassInvalid;
        const currVal_35:any = i0.ɵnov(_v,40).ngClassPending;
        _ck(_v,34,0,currVal_29,currVal_30,currVal_31,currVal_32,currVal_33,currVal_34,
            currVal_35);
        const currVal_38:any = i0.ɵnov(_v,48).ngClassUntouched;
        const currVal_39:any = i0.ɵnov(_v,48).ngClassTouched;
        const currVal_40:any = i0.ɵnov(_v,48).ngClassPristine;
        const currVal_41:any = i0.ɵnov(_v,48).ngClassDirty;
        const currVal_42:any = i0.ɵnov(_v,48).ngClassValid;
        const currVal_43:any = i0.ɵnov(_v,48).ngClassInvalid;
        const currVal_44:any = i0.ɵnov(_v,48).ngClassPending;
        _ck(_v,43,0,currVal_38,currVal_39,currVal_40,currVal_41,currVal_42,currVal_43,
            currVal_44);
        const currVal_49:any = i0.ɵnov(_v,61).ngClassUntouched;
        const currVal_50:any = i0.ɵnov(_v,61).ngClassTouched;
        const currVal_51:any = i0.ɵnov(_v,61).ngClassPristine;
        const currVal_52:any = i0.ɵnov(_v,61).ngClassDirty;
        const currVal_53:any = i0.ɵnov(_v,61).ngClassValid;
        const currVal_54:any = i0.ɵnov(_v,61).ngClassInvalid;
        const currVal_55:any = i0.ɵnov(_v,61).ngClassPending;
        _ck(_v,55,0,currVal_49,currVal_50,currVal_51,currVal_52,currVal_53,currVal_54,
            currVal_55);
        const currVal_59:any = (_co.window.isEditing? 'Update': 'Add');
        _ck(_v,69,0,currVal_59);
      });
}
export function View_WindowFormComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'window-form',
      ([] as any[]),(null as any),(null as any),(null as any),View_WindowFormComponent_0,
      RenderType_WindowFormComponent)),i0.ɵdid(1,114688,(null as any),0,i3.WindowFormComponent,
      [i7.Store,i6.CompleterService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const WindowFormComponentNgFactory:i0.ComponentFactory<i3.WindowFormComponent> = i0.ɵccf('window-form',
    i3.WindowFormComponent,View_WindowFormComponent_Host_0,{window:'window'},{submitted:'submitted',
        closed:'closed'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/components/window-form.ngfactory.ts